export default () => ({
  timezone: 'Europe/Amsterdam',
  landingPagePreferences: {
    team: null,
    library_type: null
  }
})
